module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/alli-seiffer-bc156f3980d78b1a382045426b37eb91.jpg";